module.exports = new __parcel__URL__("frt_dark.1a0db72e.png").toString();